import {Button, Card, CardBody, CardFooter, CardHeader, Checkbox, Input, Typography} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {loginService} from "../services/user/login";
import authManager from "../helper/AuthHelper";
import Validator from "../helper/validator/Validator";
import {Toaster} from "../helper/Toaster";
import PasswordField from "../components/system/passwordField";
import {ValidatorProvider} from "../helper/validator/ValidatorContext";
import {checkAll} from "../helper/validator/Check";

const Login = () => {
  const backgroundPhoto = '/assets/login-background.jpeg';
  const [loggedIn, setLoggedIn] = useState(true);
  const [isChecked, setIsChecked] = useState(false)

  useEffect(() => {
    let is_logged_in;
    is_logged_in = false
    if (localStorage.getItem('userInfo')) {
      if (localStorage.getItem('expiration')) {
        if (localStorage.getItem('token')) {
          is_logged_in = true
          window.location.href = "/loading";
          if (localStorage.getItem('defaultItem')) {
            localStorage.setItem('lastClicked', localStorage.getItem('defaultItem'));
            localStorage.removeItem('defaultItem');
          }
        }
      }
    }
    setLoggedIn(is_logged_in);
  }, []);

  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");

  const submit = async () => {
    setIsChecked(true)
    const res = checkAll();
    if (!res) {
      Toaster.failure(null,
        <Typography variant="small">
          مقادیر الزامی را بر اساس راهنما تکمیل کنید
        </Typography>
      );
      return
    }

    const data = {
      phone: mobile,
      password
    };
    if (localStorage.getItem('lastClicked')) {
      data.role_id = 3
    }

    const result = await loginService(data);

    if (result.status === 202) {
      authManager.loginHandler(result.data)
      window.location.href = "/";
    } else if (result.status === 403) {
      Toaster.failure(null, "نام کاربری یا رمز ورود اشتباه است")
    }
  };

  if (!loggedIn) {
    return (
      <ValidatorProvider>
        <div
          className={"flex justify-center items-center h-screen"}
          // className={"flex flex-col justify-center items-center mx-4 md:w-1/2 lg:w-1/3 xl:w-1/4"}
          style={{backgroundImage: `url(${backgroundPhoto})`}}
        >
          <div className="absolute inset-0 bg-black opacity-50 "></div>
          {/*<Card className="flex w-full mx-4 md:w-2/3">*/}
          <Card className="flex w-full mx-4 md:w-2/3">
            <CardHeader variant="gradient" color="gray" className="mb-4 pt-4 grid place-items-center">
              <Typography variant="h3" color="white" className="pt-4 mb-4 text-center">
                پلتفرم جامع مشاوره و خدمات کسب و کار
              </Typography>
            </CardHeader>
            <CardBody className="flex flex-col gap-4 py-8 px-4">
              <Input variant="standard" value={mobile} label="شماره همراه" size="lg" onChange={(e) => {
                setMobile(e.target.value);
              }}/>
              <Validator isChecked={isChecked} state={mobile} rules="required|num|mobile"/>
              <PasswordField variant="standard" type="password" label="رمز" size="lg" onChange={setPassword}/>
              <Validator isChecked={isChecked} state={password} rules="required"/>
              <div className="-ml-2.5">
                <Checkbox label="یادآوری کن"/>
              </div>
            </CardBody>
            <CardFooter className="pt-0">
              <Button variant="gradient" fullWidth className="mb-4" onClick={() => {
                submit();
              }}>
                ورود
              </Button>
              <Typography variant="small" className="mt-6 flex justify-center">
                قبلا ثبت‌نام نکرده‌اید؟
                <Typography as="a" href="/register" variant="small" color="blue-gray" className="mx-2 font-bold">
                  ثبت نام
                </Typography>
              </Typography>
              <Typography variant="small" className="mt-6 flex justify-center">
                رمز خود را فراموش کرده‌اید؟
                <Typography as="a" href="/forgot_password" variant="small" color="blue-gray" className="mx-2 font-bold">
                  بازنشانی رمز عبور
                </Typography>
              </Typography>
              <Typography as="a" href="https://mymobasher.com" variant="small"
                          className="mt-6 flex justify-center font-bold"
                          color="blue-gray">
                بازگشت به سایت
              </Typography>
            </CardFooter>
          </Card>
        </div>
      </ ValidatorProvider>
    );
  }
};

export default Login;
